

// import React, { useState,useEffect } from 'react';
// import './Blogcard.css';
// import { PiTagLight } from "react-icons/pi";
// import { GoComment } from "react-icons/go";
// import { FaRegUser, FaRegBookmark, FaBookmark } from "react-icons/fa";
// import { IoMdShare } from "react-icons/io";
// import { useNavigate } from 'react-router-dom';
//   import AOS from "aos";
// import "aos/dist/aos.css";

// const BlogCard = ({
//   imageUrl,
//   date,
//   month,
//   category,
//   author,
//   comments,
//   title,
//   id,
//   hasPlayButton = false,
//   isFeatured = false
// }) => {
//   const navigate = useNavigate();
//   const [isHovered, setIsHovered] = useState(false);
//   const [isBookmarked, setIsBookmarked] = useState(false);


// useEffect(() => {
//   AOS.init({ duration: 800, once: true });
// }, []);


//   const handleCardClick = () => {
//     navigate(`/blog/find-particular?_id=${id}&blog_title=${title}`);
//   };

//   const handleBookmarkClick = (e) => {
//     e.stopPropagation();
//     setIsBookmarked(!isBookmarked);
//   };


//   const handleMetaClick = (e) => {
//     e.stopPropagation();
//   };
//   return (
//     <div
//       className={`blog-card ${isFeatured ? 'featured-card' : ''}`}
//       onClick={handleCardClick}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//      data-aos={isFeatured ? "flip-left" : "fade-up"}
//   data-aos-delay="100"
//     >
//       {isFeatured && <div className="featured-badge">Featured</div>}
//       <div className='cards-position'>

//         <div className="card-image">
//           <div className='overflow'>
//             <img
//               src={imageUrl}
//               alt="Blog post"
//               className={isHovered ? 'image-zoom' : ''}
//             />
//           </div>

//           {hasPlayButton && (
//             <div className="play-button-blog">
//               <div className="play-icon-blog">
//                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
//                   <path d="M8 5V19L19 12L8 5Z" fill="#990000" />
//                 </svg>
//               </div>
//             </div>
//           )}

//           <div className="date-badge">
//             <div className="date-day">{date}</div>
//             <div className="date-month">{month}</div>
//           </div>

//           <div className={`card-actions ${isHovered ? 'visible' : ''}`}>
//             <button className="action-btn" onClick={handleBookmarkClick}>
//               {isBookmarked ? <FaBookmark /> : <FaRegBookmark />}
//             </button>
//             <button className="action-btn">
//               <IoMdShare />
//             </button>
//           </div>
//           <div className={`card-actions ${isHovered ? 'visible' : ''}`}>
//             <button className="action-btn" onClick={handleBookmarkClick}>
//               {isBookmarked ? <FaBookmark color={isHovered ? "white" : "#4D4D4D"} backgroundColor={isHovered ? "#039e06" : "#4D4D4D"} /> : <FaRegBookmark color={isHovered ? "white" : "#4D4D4D"} backgroundColor={isHovered ? "#039e06" : "#4D4D4D"} />}
//             </button>
//             <button className="action-btn">
//               <IoMdShare color={isHovered ? "white" : "#4D4D4D"} />
//             </button>
//           </div>
//         </div>

//         <div className="card-info">
//           <div className="meta-info">
//             {/* <div className="meta-item category-tag" onClick={handleMetaClick}>
//               <PiTagLight />
//               <span>{category}</span>
//             </div> */}

//             <div className="meta-divider">•</div>

//             <div className="meta-item" onClick={handleMetaClick}>
//               <FaRegUser />
//               <span>By {author}</span>
//             </div>

//             <div className="meta-divider">•</div>

//             <div className="meta-item">
//               {/* <GoComment/> */}
//               {/* <span>{comments} Comments</span> */}
//               {/* <span> Comments</span> */}

//             </div>
//           </div>

//           <h3 className="card-title-blog">{title}</h3>

//           <div className="read-more">
//             <span>Read More</span>
//             <svg className="arrow-icon" width="15" height="12" viewBox="0 0 15 12" fill="none">
//               <path d="M1 6H13" stroke="#CC0000" strokeWidth="1.5" strokeLinecap="round" />
//               <path d="M8 11L13 6" stroke="#CC0000" strokeWidth="1.5" strokeLinecap="round" />
//               <path d="M8 1L13 6" stroke="#CC0000" strokeWidth="1.5" strokeLinecap="round" />
//             </svg>
//           </div>

//           <div className="progress-indicator">
//             <div className="progress-bar" style={{ width: `${Math.random() * 100}%` }}></div>
//           </div>
//         </div>
//       </div>


//     </div>
//   );
// };

// export default BlogCard;

import React, { useState, useEffect } from 'react';
import './Blogcard.css';
import { PiTagLight } from "react-icons/pi";
import { GoComment } from "react-icons/go";
import { FaRegUser, FaRegBookmark, FaBookmark } from "react-icons/fa";
import { IoMdShare } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";

const BlogCard = ({
  imageUrl,
  date,
  month,
  category,
  author,
  comments,
  title,
  id,
  hasPlayButton = false,
  isFeatured = false,
  isLoading = false // New prop to control loading state
}) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const handleCardClick = () => {
    if (!isLoading) { // Prevent navigation if still loading
      navigate(`/blog/find-particular?_id=${id}&blog_title=${title}`);
    }
  };

  const handleBookmarkClick = (e) => {
    e.stopPropagation();
    setIsBookmarked(!isBookmarked);
  };

  const handleMetaClick = (e) => {
    e.stopPropagation();
  };

  if (isLoading) {
    return (
      <div className={`skeleton-blog-card ${isFeatured ? 'skeleton-blog-card--featured' : ''}`}>
        <div className='skeleton-blog-card__position'>
          {isFeatured && <div className="skeleton-blog-card__featured-badge"></div>}
          <div className="skeleton-blog-card__image-wrapper">
            <div className="skeleton-blog-card__image-placeholder"></div>
            <div className="skeleton-blog-card__date-badge">
              <div className="skeleton-blog-card__line skeleton-blog-card__line--short"></div>
              <div className="skeleton-blog-card__line skeleton-blog-card__line--shortest"></div>
            </div>
            <div className="skeleton-blog-card__actions">
              <div className="skeleton-blog-card__icon"></div>
              <div className="skeleton-blog-card__icon"></div>
            </div>
          </div>
          <div className="skeleton-blog-card__info">
            <div className="skeleton-blog-card__meta-info">
              <div className="skeleton-blog-card__line skeleton-blog-card__line--small"></div>
              <div className="skeleton-blog-card__line skeleton-blog-card__line--medium"></div>
            </div>
            <div className="skeleton-blog-card__line skeleton-blog-card__line--large"></div>
            <div className="skeleton-blog-card__line skeleton-blog-card__line--medium"></div>
            <div className="skeleton-blog-card__read-more">
              <div className="skeleton-blog-card__line skeleton-blog-card__line--small"></div>
            </div>
            <div className="skeleton-blog-card__progress-indicator">
              <div className="skeleton-blog-card__progress-bar"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`blog-card ${isFeatured ? 'featured-card' : ''}`}
      onClick={handleCardClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-aos={isFeatured ? "flip-left" : "fade-up"}
      data-aos-delay="100"
    >
      {isFeatured && <div className="featured-badge">Featured</div>}
      <div className='cards-position'>

        <div className="card-image">
          <div className='overflow'>
            <img
              src={imageUrl}
              alt="Blog post"
              className={isHovered ? 'image-zoom' : ''}
            />
          </div>

          {hasPlayButton && (
            <div className="play-button-blog">
              <div className="play-icon-blog">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M8 5V19L19 12L8 5Z" fill="#990000" />
                </svg>
              </div>
            </div>
          )}

          <div className="date-badge">
            <div className="date-day">{date}</div>
            <div className="date-month">{month}</div>
          </div>

          <div className={`card-actions ${isHovered ? 'visible' : ''}`}>
            <button className="action-btn" onClick={handleBookmarkClick}>
              {isBookmarked ? <FaBookmark color={isHovered ? "white" : "#4D4D4D"} /> : <FaRegBookmark color={isHovered ? "white" : "#4D4D4D"} />}
            </button>
            <button className="action-btn">
              <IoMdShare color={isHovered ? "white" : "#4D4D4D"} />
            </button>
          </div>
        </div>

        <div className="card-info">
          <div className="meta-info">
            {/* <div className="meta-item category-tag" onClick={handleMetaClick}>
              <PiTagLight />
              <span>{category}</span>
            </div> */}

            <div className="meta-divider">•</div>

            <div className="meta-item" onClick={handleMetaClick}>
              <FaRegUser />
              <span>By {author}</span>
            </div>

            <div className="meta-divider">•</div>

            <div className="meta-item">
              {/* <GoComment/> */}
              {/* <span>{comments} Comments</span> */}
              {/* <span> Comments</span> */}
            </div>
          </div>

          <h3 className="card-title-blog">{title}</h3>

          <div className="read-more">
            <span>Read More</span>
            <svg className="arrow-icon" width="15" height="12" viewBox="0 0 15 12" fill="none">
              <path d="M1 6H13" stroke="#CC0000" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M8 11L13 6" stroke="#CC0000" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M8 1L13 6" stroke="#CC0000" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </div>

          <div className="progress-indicator">
            <div className="progress-bar" style={{ width: `${Math.random() * 100}%` }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
